export const translations = {
    en: {
        // Header
        nav: {
            home: "Home",
            about: "About",
            services: "Services",
            portfolio: "Portfolio",
            contact: "Contact"
        },
        // Home Page
        home: {
            hero: {
                title: ["Your ", "Success", " Drives Our Mission"],
                subtitle: "We design, develop, launch, and maintain digital solutions that fuel business growth. Because we only thrive when you thrive.",
                cta: "Start Your Journey",
                arrow: "→"
            },
            cards: {
                innovation: "Innovation",
                growth: "Growth",
                successRate: "Success Rate"
            },
            services: {
                label: "WHAT WE DO",
                title: "Comprehensive Solutions",
                subtitle: "From concept to launch and beyond, we're your complete technology partner",
                design: {
                    title: "Design",
                    description: "User-centric design that captures your brand essence and creates memorable digital experiences that convert visitors into customers.",
                    features: ["UI/UX Design", "Brand Identity & Strategy", "Design Systems", "User Research & Testing", "Prototyping"]
                },
                development: {
                    title: "Development",
                    description: "Robust, scalable solutions built with cutting-edge technologies and industry best practices for maximum performance.",
                    features: ["Web Application Development", "Mobile App Development", "Custom Software Solutions", "E-commerce Platforms", "API Development & Integration", "Database Design & Optimization"]
                },
                launch: {
                    title: "Launch",
                    description: "Strategic deployment ensuring your solution reaches your audience with maximum impact and minimal downtime.",
                    features: ["Cloud Infrastructure Setup", "Performance Optimization", "Security Hardening", "Load Testing & QA", "SEO Optimization", "Launch Strategy & Support"]
                },
                maintenance: {
                    title: "Maintenance",
                    description: "Ongoing support and evolution to keep your solution performing at its peak and adapting to changing needs.",
                    features: ["24/7 Technical Support", "Regular Updates & Patches", "Security Monitoring", "Performance Analytics", "Feature Enhancements", "Backup & Disaster Recovery"]
                }
            },
            process: {
                label: "HOW WE WORK",
                title: "Our Process",
                subtitle: "A proven methodology that transforms ideas into successful digital products",
                steps: [
                    { title: "Discover", description: "We dive deep into your business goals, challenges, and opportunities" },
                    { title: "Strategize", description: "Create a comprehensive strategy aligned with your objectives" },
                    { title: "Execute", description: "Build and refine your solution" },
                    { title: "Grow", description: "Continuous optimization based on data and feedback" }
                ]
            },
            cta: {
                title: "Ready to Grow Together?",
                subtitle: "Let's build something extraordinary. Your success story starts with a conversation.",
                button: "Get in Touch"
            }
        },
        // About Page
        about: {
            label: "WHO WE ARE",
            title: "About GIGGALAB",
            description: "We're a team of passionate technologists dedicated to helping businesses grow.",
            legal: "Our company is registered as an individual activity in Lithuania and is subject to Lithuanian laws."
        },
        // Services Page
        services: {
            label: "WHAT WE DO",
            title: "Our Services",
            subtitle: "Comprehensive IT solutions designed to transform your business and drive success",
            cta: "Get in Touch",
            design: {
                title: "Design",
                description: "User-centric design that captures your brand essence and creates memorable digital experiences that convert visitors into customers.",
                features: ["UI/UX Design", "Brand Identity & Strategy", "Design Systems", "User Research & Testing", "Prototyping"]
            },
            development: {
                title: "Development",
                description: "Robust, scalable solutions built with cutting-edge technologies and industry best practices for maximum performance.",
                features: ["Web Application Development", "Mobile App Development", "Custom Software Solutions", "E-commerce Platforms", "API Development & Integration", "Database Design & Optimization"]
            },
            launch: {
                title: "Launch",
                description: "Strategic deployment ensuring your solution reaches your audience with maximum impact and minimal downtime.",
                features: ["Cloud Infrastructure Setup", "Performance Optimization", "Security Hardening", "Load Testing & QA", "SEO Optimization", "Launch Strategy & Support"]
            },
            maintenance: {
                title: "Maintenance",
                description: "Ongoing support and evolution to keep your solution performing at its peak and adapting to changing needs.",
                features: ["24/7 Technical Support", "Regular Updates & Patches", "Security Monitoring", "Performance Analytics", "Feature Enhancements", "Backup & Disaster Recovery"]
            }
        },
        // Portfolio Page
        portfolio: {
            label: "OUR WORK",
            title: "Portfolio",
            subtitle: "Discover how we've helped businesses elevate their online impact",
            loading: "Loading projects...",
            visitWebsite: "Visit Website"
        },
        // Contact Page
        contact: {
            label: "GET IN TOUCH",
            title: "Contact Us",
            subtitle: "Have a project in mind? Let's discuss how we can help transform your business",
            formNote: "Fill out this form or contact us via contacts below",
            success: {
                title: "Message Sent Successfully!",
                message: "We'll get back to you within 8 hours."
            },
            form: {
                fullName: "Full Name",
                email: "Email Address",
                phone: "Phone Number",
                company: "Company Name",
                service: "Service Interested In",
                budget: "Project Budget",
                message: "Project Details",
                required: "*",
                placeholders: {
                    name: "John Doe",
                    email: "john@example.com",
                    phone: "+370 000 00000",
                    company: "Your Company",
                    message: "Tell us about your project, goals, timeline, and any specific requirements..."
                },
                serviceOptions: {
                    select: "Select a service",
                    design: "Design",
                    development: "Development",
                    launch: "Launch",
                    maintenance: "Maintenance",
                    consulting: "Consulting",
                    fullPackage: "Full Package"
                },
                budgetOptions: {
                    select: "Select budget range",
                    range1: "€0 - €50",
                    range2: "€50 - €200",
                    range3: "€200 - €500",
                    range4: "€500+"
                },
                submit: "Send Message"
            },
            info: {
                email: "Email",
                phone: "Phone",
                phoneHours: "Mon-Fri, 9:00 AM - 6:00 PM GMT +2",
                location: "Location",
                locationDetails: ["Vilnius, Lithuania", "European Union"]
            }
        },
        // Footer
        footer: {
            company: "GIGGALAB",
            tagline: "Your success is our mission. We create digital solutions that drive real business results.",
            services: "Services",
            servicesList: ["Design", "Development", "Launch", "Maintenance"],
            companySection: "Company",
            companyLinks: ["About Us", "Portfolio"],
            connect: "Connect",
            connectLinks: ["LinkedIn", "Instagram", "Contact"],
            copyright: "2026 GIGGALAB. Your Success, Our Mission."
        },
        // Chat Widget
        chat: {
            title: "GiggaLAB Support",
            status: "Online",
            placeholder: "Type your message...",
            welcome: "Hello! How can we help you today? 👋",
            greeting: "Hello! How can I assist you today?",
            servicesResponse: "We offer web development, mobile apps, AI/ML solutions, and more. Visit our Services page for details!",
            priceResponse: "Our pricing varies depending on project scope and specific requirements. We offer a monthly payment plan with a lower upfront cost and reduced financial risk for our customers. Typically, the monthly fee ranges from €30 to €100, including domain and hosting services, and is determined by the complexity of the project. For a detailed quote tailored to your needs, please contact our team at team@giggalab.com or visit our Contact page.",
            contactResponse: "You can reach us at team@giggalab.com or through our Contact page. We'll get back to you within 8 hours!",
            portfolioResponse: "Check out our Portfolio page to see our latest projects!",

            // Company Information
            aboutResponse: "GIGGALAB is a technology company based in Vilnius, Lithuania. We're passionate about helping businesses grow through innovative digital solutions. Our mission: Your Success Drives Our Mission!",
            locationResponse: "We're located in Vilnius, Lithuania, in the heart of the European Union. We work with clients both locally and internationally!",
            teamResponse: "We're a team of passionate developers, designers, and technology experts dedicated to delivering excellence. We combine creativity with technical expertise to build solutions that drive real results!",

            // Business Details
            hoursResponse: "Our support team is available Monday to Friday, 9:00 AM - 6:00 PM (GMT+2). For urgent matters, you can always email us at team@giggalab.com!",
            experienceResponse: "We have extensive experience in web development, mobile apps, AI/ML solutions, and digital transformation. Each project is tailored to meet specific business goals!",
            industriesResponse: "We work with businesses across various industries including e-commerce, healthcare, fintech, education, and more. Every industry has unique challenges, and we love solving them!",

            // Technical Information
            technologiesResponse: "We use cutting-edge technologies including React, Node.js, Python, AI/ML frameworks, cloud platforms (AWS, Azure, Google Cloud), and more. We always choose the best tech stack for your specific needs!",
            processResponse: "Our process: 1) Discover - understanding your needs, 2) Strategize - planning the solution, 3) Execute - building and testing, 4) Grow - ongoing support and optimization. Visit our website to learn more!",
            timelineResponse: "Project timelines vary based on scope and complexity. Simple projects can take 2-4 weeks, while complex solutions may take 2-6 months. Contact us at team@giggalab.com for a specific timeline!",

            // Support & Maintenance
            supportResponse: "We offer 24/7 technical support, regular updates, security monitoring, and performance optimization. Your success is ongoing, and so is our support!",
            maintenanceResponse: "Our maintenance services include regular updates, security patches, performance monitoring, backup management, and feature enhancements. We keep your solution running smoothly!",

            // Common Questions
            whyChooseResponse: "We're different because your success is literally our mission. We don't just deliver projects - we become your technology partner. We only thrive when you thrive!",
            startResponse: "Getting started is easy! Contact us at team@giggalab.com or fill out our Contact form. We'll schedule a free consultation to discuss your project and goals!",
            guaranteeResponse: "We're committed to delivering high-quality solutions. We work closely with you throughout the process, ensuring the final product meets your expectations and business goals!",

            // Default
            defaultResponse: "Thank you for your message! For specific inquiries about pricing, services, or projects, please contact us at team@giggalab.com or visit our Contact page."
        }
    },
    lt: {
        // Header
        nav: {
            home: "Pagrindinis",
            about: "Apie mus",
            services: "Paslaugos",
            portfolio: "Projektai",
            contact: "Kontaktai"
        },
        // Home Page
        home: {
            hero: {
                title: ["Jūsų ", "sėkmė", " skatina mūsų misiją"],
                subtitle: "Kuriame, kuriame, paleidžiame ir prižiūrime skaitmenines sistemas, skatinančias verslo augimą. Nes mes klestime tik tada, kai klestite jūs.",
                cta: "Pradėkite kelionę",
                arrow: "→"
            },
            cards: {
                innovation: "Inovacijos",
                growth: "Augimas",
                successRate: "Sėkmės rodiklis"
            },
            services: {
                label: "KĄ MES DAROME",
                title: "Išsamūs sprendimai",
                subtitle: "Nuo koncepcijos iki paleidimo ir toliau, mes esame jūsų visapusiškas technologijų partneris",
                design: {
                    title: "Dizainas",
                    description: "Į vartotoją orientuotas dizainas, atspindintis jūsų prekės ženklo esmę ir sukuriantis įsimintiną skaitmeninę patirtį, kuri paverčia lankytojus klientais.",
                    features: ["UI/UX dizainas", "Prekės ženklo identitetas ir strategija", "Dizaino sistemos", "Vartotojo tyrimai ir testavimas", "Prototipų kūrimas"]
                },
                development: {
                    title: "Kūrimas",
                    description: "Patvarūs, plečiami sprendimai, sukurti naudojant naujausias technologijas ir geriausią pramonės praktiką maksimaliam našumui.",
                    features: ["Internetinių programų kūrimas", "Mobilių programų kūrimas", "Individualūs programinės įrangos sprendimai", "El. prekybos platformos", "API kūrimas ir integracija", "Duomenų bazių projektavimas ir optimizavimas"]
                },
                launch: {
                    title: "Paleidimas",
                    description: "Strateginis diegimas, užtikrinantis, kad jūsų sprendimas pasiektų jūsų auditoriją su didžiausiu poveikiu ir minimaliu prastova.",
                    features: ["Debesų infrastruktūros sąranka", "Našumo optimizavimas", "Saugumo sustiprinimas", "Apkrovos testavimas ir kokybė", "SEO optimizavimas", "Paleidimo strategija ir palaikymas"]
                },
                maintenance: {
                    title: "Priežiūra",
                    description: "Nuolatinis palaikymas ir evoliucija, kad jūsų sprendimas veiktų maksimaliu našumu ir prisitaikytų prie kintančių poreikių.",
                    features: ["24/7 techninė pagalba", "Reguliarūs atnaujinimai ir pataisymai", "Saugumo stebėjimas", "Našumo analizė", "Funkcijų tobulinimas", "Atsarginė kopija ir avarinė atkūrimas"]
                }
            },
            process: {
                label: "KAIP MES DIRBAME",
                title: "Mūsų procesas",
                subtitle: "Įrodyta metodologija, kuri paverčia idėjas sėkmingais skaitmeniniais produktais",
                steps: [
                    { title: "Atradimas", description: "Mes gilinimės į jūsų verslo tikslus, iššūkius ir galimybes" },
                    { title: "Strategija", description: "Kuriame išsamią strategiją, atitinkančią jūsų tikslus" },
                    { title: "Vykdymas", description: "Kuriame ir tobuliname jūsų sprendimą" },
                    { title: "Augimas", description: "Nuolatinis optimizavimas pagal duomenis ir atsiliepimus" }
                ]
            },
            cta: {
                title: "Pasiruošę augti kartu?",
                subtitle: "Sukurkime kažką nepaprasto. Jūsų sėkmės istorija prasideda nuo pokalbio.",
                button: "Susisiekite"
            }
        },
        // About Page
        about: {
            label: "KAS MES ESAME",
            title: "Apie GIGGALAB",
            description: "Mes esame aistringų technologų komanda, skirta padėti verslui augti.",
            legal: "Mūsų įmonė registruota kaip individuali veikla Lietuvoje ir yra valdoma Lietuvos įstatymų."
        },
        // Services Page
        services: {
            label: "KĄ MES DAROME",
            title: "Mūsų paslaugos",
            subtitle: "Išsamūs IT sprendimai, sukurti transformuoti jūsų verslą ir skatinti sėkmę",
            cta: "Susisiekite",
            design: {
                title: "Dizainas",
                description: "Į vartotoją orientuotas dizainas, atspindintis jūsų prekės ženklo esmę ir sukuriantis įsimintiną skaitmeninę patirtį, kuri paverčia lankytojus klientais.",
                features: ["UI/UX dizainas", "Prekės ženklo identitetas ir strategija", "Dizaino sistemos", "Vartotojo tyrimai ir testavimas", "Prototipų kūrimas"]
            },
            development: {
                title: "Kūrimas",
                description: "Patvarūs, plečiami sprendimai, sukurti naudojant naujausias technologijas ir geriausią pramonės praktiką maksimaliam našumui.",
                features: ["Internetinių programų kūrimas", "Mobilių programų kūrimas", "Individualūs programinės įrangos sprendimai", "El. prekybos platformos", "API kūrimas ir integracija", "Duomenų bazių projektavimas ir optimizavimas"]
            },
            launch: {
                title: "Paleidimas",
                description: "Strateginis diegimas, užtikrinantis, kad jūsų sprendimas pasiektų jūsų auditoriją su didžiausiu poveikiu ir minimaliu prastova.",
                features: ["Debesų infrastruktūros sąranka", "Našumo optimizavimas", "Saugumo sustiprinimas", "Apkrovos testavimas ir kokybė", "SEO optimizavimas", "Paleidimo strategija ir palaikymas"]
            },
            maintenance: {
                title: "Priežiūra",
                description: "Nuolatinis palaikymas ir evoliucija, kad jūsų sprendimas veiktų maksimaliu našumu ir prisitaikytų prie kintančių poreikių.",
                features: ["24/7 techninė pagalba", "Reguliarūs atnaujinimai ir pataisymai", "Saugumo stebėjimas", "Našumo analizė", "Funkcijų tobulinimas", "Atsarginė kopija ir avarinė atkūrimas"]
            }
        },
        // Portfolio Page
        portfolio: {
            label: "MŪSŲ DARBAI",
            title: "Projektai",
            subtitle: "Sužinokite, kaip padėjome verslui pagerinti savo įtaką internete",
            loading: "Kraunami projektai...",
            visitWebsite: "Aplankykite svetainę"
        },
        // Contact Page
        contact: {
            label: "SUSISIEKITE",
            title: "Susisiekite su mumis",
            subtitle: "Turite projektą mintyse? Aptarkime, kaip galime padėti transformuoti jūsų verslą",
            formNote: "Užpildykite šią formą arba susisiekite su mumis per žemiau pateiktus kontaktus",
            success: {
                title: "Žinutė sėkmingai išsiųsta!",
                message: "Atsakysime per 8 valandas."
            },
            form: {
                fullName: "Vardas ir pavardė",
                email: "El. pašto adresas",
                phone: "Telefono numeris",
                company: "Įmonės pavadinimas",
                service: "Dominanti paslauga",
                budget: "Projekto biudžetas",
                message: "Projekto detalės",
                required: "*",
                placeholders: {
                    name: "Vardenis Pavardenis",
                    email: "vardas@pavyzdys.lt",
                    phone: "+370 000 00000",
                    company: "Jūsų įmonė",
                    message: "Papasakokite apie savo projektą, tikslus, terminus ir bet kokius konkrečius reikalavimus..."
                },
                serviceOptions: {
                    select: "Pasirinkite paslaugą",
                    design: "Dizainas",
                    development: "Kūrimas",
                    launch: "Paleidimas",
                    maintenance: "Priežiūra",
                    consulting: "Konsultavimas",
                    fullPackage: "Pilnas paketas"
                },
                budgetOptions: {
                    select: "Pasirinkite biudžeto ribas",
                    range1: "€0 - €50",
                    range2: "€50 - €200",
                    range3: "€200 - €500",
                    range4: "€500+"
                },
                submit: "Siųsti žinutę"
            },
            info: {
                email: "El. paštas",
                phone: "Telefonas",
                phoneHours: "Pr-Pn, 9:00 - 18:00 GMT +2",
                location: "Vieta",
                locationDetails: ["Vilnius, Lietuva", "Europos Sąjunga"]
            }
        },
        // Footer
        footer: {
            company: "GIGGALAB",
            tagline: "Jūsų sėkmė yra mūsų misija. Kuriame skaitmenines sistemas, kurios sukuria realius verslo rezultatus.",
            services: "Paslaugos",
            servicesList: ["Dizainas", "Kūrimas", "Paleidimas", "Priežiūra"],
            companySection: "Įmonė",
            companyLinks: ["Apie mus", "Projektai"],
            connect: "Susisiekite",
            connectLinks: ["LinkedIn", "Instagram", "Kontaktai"],
            copyright: "2026 GIGGALAB. Jūsų sėkmė, mūsų misija."
        },
        // Chat Widget
        chat: {
            title: "GiggaLAB Pagalba",
            status: "Prisijungę",
            placeholder: "Rašykite žinutę...",
            welcome: "Sveiki! Kaip galime jums padėti? 👋",
            greeting: "Sveiki! Kaip galiu jums padėti?",
            servicesResponse: "Siūlome internetinių svetainių kūrimą, mobiliąsias programas, AI/ML sprendimus ir dar daugiau. Aplankykite mūsų Paslaugų puslapį!",
            priceResponse: "Mūsų kainos priklauso nuo projekto apimties ir konkrečių reikalavimų. Siūlome mėnesinį mokėjimo planą su mažesne pradinė kaina ir sumažinta finansine rizika mūsų klientams. Paprastai mėnesinis mokestis svyruoja nuo 30 iki 100 €, įskaitant domeno ir talpinimo paslaugas, ir priklauso nuo projekto sudėtingumo. Norėdami gauti detalią pasiūlymą, pritaikytą jūsų poreikiams, susisiekite su mūsų komanda el. paštu team@giggalab.com arba aplankykite Kontaktų puslapį.",
            contactResponse: "Galite mus pasiekti el. paštu team@giggalab.com arba per Kontaktų puslapį. Atsakysime per 8 valandas!",
            portfolioResponse: "Peržiūrėkite mūsų Projektų puslapį, kad pamatytumėte naujausius darbus!",

            // Informacija apie įmonę
            aboutResponse: "GIGGALAB yra technologijų įmonė, įsikūrusi Vilniuje, Lietuvoje. Mes esame aistringi padėti verslui augti per inovatyvius skaitmeninius sprendimus. Mūsų misija: Jūsų sėkmė skatina mūsų misiją!",
            locationResponse: "Esame Vilniuje, Lietuvoje, Europos Sąjungos širdyje. Dirbame su klientais tiek vietoje, tiek tarptautiniu mastu!",
            teamResponse: "Mes esame aistringų kūrėjų, dizainerių ir technologijų ekspertų komanda, skirta teikti puikius rezultatus. Derinome kūrybiškumą su technine patirtimi, kad sukurtume sprendimus, kurie duoda realių rezultatų!",

            // Verslo informacija
            hoursResponse: "Mūsų pagalbos komanda dirba pirmadieniais-penktadieniais, 9:00 - 18:00 (GMT+2). Skubiais atvejais visada galite parašyti el. paštu team@giggalab.com!",
            experienceResponse: "Turime didelę patirtį internetinių svetainių kūrime, mobiliosiose programose, AI/ML sprendimuose ir skaitmeninėje transformacijoje. Kiekvienas projektas pritaikomas konkretiems verslo tikslams!",
            industriesResponse: "Dirbame su įmonėmis įvairiose pramonės šakose, įskaitant el. prekybą, sveikatos priežiūrą, finansų technologijas, švietimą ir kt. Kiekviena pramonės šaka turi unikalių iššūkių, ir mums patinka juos spręsti!",

            // Techninė informacija
            technologiesResponse: "Naudojame naujausias technologijas, įskaitant React, Node.js, Python, AI/ML frameworks, debesų platformas (AWS, Azure, Google Cloud) ir daugiau. Visada parenkame geriausią technologijų rinkinį jūsų konkretiems poreikiams!",
            processResponse: "Mūsų procesas: 1) Atradimas - jūsų poreikių supratimas, 2) Strategija - sprendimo planavimas, 3) Vykdymas - kūrimas ir testavimas, 4) Augimas - nuolatinis palaikymas ir optimizavimas. Aplankykite mūsų svetainę ir sužinokite daugiau!",
            timelineResponse: "Projekto trukmė priklauso nuo apimties ir sudėtingumo. Paprasti projektai gali užtrukti 2-4 savaites, o sudėtingi sprendimai - 2-6 mėnesius. Susisiekite su mumis el. paštu team@giggalab.com ir sužinokite konkrečią trukmę!",

            // Palaikymas ir priežiūra
            supportResponse: "Siūlome 24/7 techninę pagalbą, reguliarius atnaujinimus, saugumo stebėjimą ir našumo optimizavimą. Jūsų sėkmė yra nuolatinė, todėl ir mūsų palaikymas!",
            maintenanceResponse: "Mūsų priežiūros paslaugos apima reguliarius atnaujinimus, saugumo pataisymus, našumo stebėjimą, atsarginių kopijų valdymą ir funkcijų tobulinimą. Palaikome jūsų sprendimą sklandžiai veikiantį!",

            // Dažni klausimai
            whyChooseResponse: "Mes skirtingi, nes jūsų sėkmė yra tiesiogiai mūsų misija. Mes ne tik pristatome projektus - tampame jūsų technologijų partneriu. Mes klestime tik tada, kai klestite jūs!",
            startResponse: "Pradėti lengva! Susisiekite su mumis el. paštu team@giggalab.com arba užpildykite mūsų Kontaktų formą. Suplanuosime nemokamą konsultaciją, kad aptartume jūsų projektą ir tikslus!",
            guaranteeResponse: "Esame įsipareigoję teikti aukštos kokybės sprendimus. Glaudžiai bendradarbiaujame su jumis visame procese, užtikrindami, kad galutinis produktas atitiktų jūsų lūkesčius ir verslo tikslus!",

            // Numatytasis
            defaultResponse: "Ačiū už jūsų žinutę! Jei turite konkrečių klausimų apie kainas, paslaugas ar projektus, susisiekite su mumis el. paštu team@giggalab.com arba aplankykite Kontaktų puslapį."
        }
    }
};
